import { Button, ButtonProps } from '@/components/ui/Button';
import { cn } from '@/lib/helpers/utils';
import React, { PropsWithChildren } from 'react';
import { showMatchInbox, showUserMessages } from '../../../app/redux/actions/userMatchActions';
import { useAppDispatch, useAppSelector } from '../../../app/redux/hooks';
import { UserMatch, UserMatchesState } from '../../../app/redux/reducers/userMatchesReducer';
import { asyncTrackingEvent, asyncTrackingEventProps } from '../../../app/utils/tracking';

interface ViewMessagesProps extends Omit<PropsWithChildren<ButtonProps>, 'children'> {
  children: (numberOfMatches: number, numberOfMatchesUnread: number) => React.ReactNode;
}

export const ViewMessages = React.forwardRef<HTMLButtonElement, ViewMessagesProps>(
  ({ variant = 'bare', appearance = 'foreground', children, onClick, ...props }, ref) => {
    const dispatch = useAppDispatch();

    const { matches } = useAppSelector((state) => state.matches) as UserMatchesState;
    const numMatches = matches?.length;
    const numMatchesUnread = matches.filter((match: UserMatch) => !match.seen).length;

    const onViewMessages = () => {
      const event: asyncTrackingEventProps = {
        track: 'audience_builder_open_panel_click',
        trackAbacus: 'audience_builder_open_panel_click',
        trackText: numMatches
      };
      asyncTrackingEvent(event);
      dispatch(showUserMessages(true));
      dispatch(showMatchInbox(true));
    };

    return (
      <Button
        ref={ref}
        {...props}
        onClick={(event) => {
          onClick && onClick(event);
          onViewMessages();
        }}
        variant={variant}
        appearance={appearance}
      >
        {children(numMatches, numMatchesUnread)}
      </Button>
    );
  }
);

interface ViewMessagesCountBadgeProps extends React.HTMLAttributes<HTMLDivElement> {}

export const ViewMessagesCountBadge = ({ children, className, ...props }: ViewMessagesCountBadgeProps) => {
  return (
    <div
      {...props}
      className={cn(
        'size-5 max-w-5 max-h-5 flex justify-center items-center bg-shock text-white text-[10px] rounded-full font-medium',
        className
      )}
    >
      {children}
    </div>
  );
};
